import { useState } from 'react';
import Button from '../base/Button';
import BookingCalendar from './BookingCalendar';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onContactClick?: () => void;
}

export default function Header({ onContactClick }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const navigate = useNavigate();

  const openBookingCalendar = () => {
    setIsBookingOpen(true);
  };

  const navigateToSection = (id: string) => {
    navigate('/');
    setTimeout(() => {
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onContactClick) {
      onContactClick();
    } else {
      const element = document.getElementById('contatti');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate('/');
        setTimeout(() => {
          const target = document.getElementById('contatti');
          if (target) target.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  };

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <a href="/" className="flex items-center cursor-pointer group">
                <div className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  AffittoOnline.it
                </div>
              </a>
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <a href="#servizi" onClick={(e) => { e.preventDefault(); navigateToSection('servizi'); }} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Servizi
              </a>
              <a href="#come-funziona" onClick={(e) => { e.preventDefault(); navigateToSection('come-funziona'); }} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Come Funziona
              </a>
              <a href="#prezzi" onClick={(e) => { e.preventDefault(); navigateToSection('prezzi'); }} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Prezzi
              </a>
              <button 
                onClick={() => navigate('/chi-sono')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Chi Sono
              </button>
              <a 
                href="#contatti" 
                onClick={handleContactClick}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Contatti
              </a>
            </nav>

            <div className="hidden md:flex items-center space-x-4">
              <Button 
                variant="outline" 
                size="sm"
                onClick={openBookingCalendar}
              >
                Consulenza Gratuita
              </Button>
              <Button 
                size="sm"
                onClick={openBookingCalendar}
              >
                Prenota Ora
              </Button>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="text-gray-700 hover:text-blue-600 cursor-pointer"
              >
                <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden absolute top-20 left-0 right-0 bg-white shadow-lg border-t border-gray-200">
              <nav className="flex flex-col p-4 space-y-4">
                <a href="#servizi" onClick={(e) => { e.preventDefault(); navigateToSection('servizi'); setIsMobileMenuOpen(false); }} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                  Servizi
                </a>
                <a href="#come-funziona" onClick={(e) => { e.preventDefault(); navigateToSection('come-funziona'); setIsMobileMenuOpen(false); }} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                  Come Funziona
                </a>
                <a href="#prezzi" onClick={(e) => { e.preventDefault(); navigateToSection('prezzi'); setIsMobileMenuOpen(false); }} className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                  Prezzi
                </a>
                <button 
                  onClick={() => {
                    navigate('/chi-sono');
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left"
                >
                  Chi Sono
                </button>
                <a 
                  href="#contatti" 
                  onClick={(e) => {
                    handleContactClick(e);
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  Contatti
                </a>
                <div className="flex flex-col space-y-2 pt-4">
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => {
                      openBookingCalendar();
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Consulenza Gratuita
                  </Button>
                  <Button 
                    size="sm"
                    onClick={() => {
                      openBookingCalendar();
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Prenota Ora
                  </Button>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>

      <BookingCalendar 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />
    </>
  );
}
